import 'babel-polyfill';

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');

import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';

import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify, {
    lang: {
        locales: { de },
        current: 'de'
    }
});
Vue.use(VueRouter);
Vue.use(VueI18n);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { mapState } from 'vuex';

import router from './router';
import store from './store';
import translations from './translations';

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {

        store.dispatch('logout');

        router.push('/login');

        store.commit('snackBar', {
            color: 'warning',
            text: 'Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.'
        });
    }

    return Promise.reject(error);
});

const i18n = new VueI18n({
    locale: 'de', // set locale
    messages: translations, // set locale messages
    numberFormats: {
        'de': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
            }
        },
        'en': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
            }
        }
    }
});

import App from './components/App';

const app = new Vue({
    el: '#app',
    i18n,
    components: {
        'app': App
    },
    computed: {
        ...mapState(['user', 'users', 'starterTemplates', 'events', 'dialogs', 'dancers', 'registrations', 'snackBar'])
    },
    router: router,
    store: store,
    created() {
        Vue.prototype.$hasRole = this.hasRole;
        Vue.prototype.$formatDate = date => window.moment(date).locale(i18n.locale).format('L');
        Vue.prototype.$formatDateTime = date => window.moment(date).locale(i18n.locale).format('lll');
        Vue.prototype.$currency = (value, htmlMode) => {
            if (htmlMode !== undefined && htmlMode) {
                return Math.round(value/100).toFixed(2).replace('.', ',') + ' EUR';
            }

            return this.$n(value/100, 'currency');
        };
        Vue.prototype.$toUpperCase = string => string.toUpperCase();
        Vue.prototype.$log = console.log.bind(console);
        Vue.prototype.$join = value => _.join(value, ', ');
        Vue.prototype.$trimText = value => value.length > 50 ? value.substr(0, 50) + '...' : value;
    },
    methods: {
        hasRole(role) {
            if (!this.user || !this.user.roles) {
                return false;
            }

            return this.user.roles.includes(role);
        }
    }
});

router.beforeEach((to, from, next) => {
    let user = app.$store.state.user;

    if (to.meta.requiresAuth && user === null) {
        return next(false);
    }

    if (app.$hasRole('admin')) {
        return next();
    }

    if (user !== null && !user.valid && to.path !== '/user/welcome') {
        return next(false);
    }

    next();
});

/*router.afterEach((to, from) => {
    _paq.push(['setCustomUrl', '/' + window.location.hash.substr(1)]);
    _paq.push(['setDocumentTitle', 'My New Title']);
    _paq.push(['trackPageView']);
});*/
